// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"200":"02d4eefd","714":"383b0a69"}[chunkId] + ".chunk.css";
};